'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Dialog } from '@module/mdrt-org/shared/components/dialog/dialog';
import { patchAccountSettingsAction } from '@module/mdrt-org/shared/utils/data/patch-account-settings-action';
import { AccountSettingsFormStep } from '@module/mdrt-org/shared/utils/enums/account-settings-form-step';
import { AccountSettingsMutationKey } from '@module/mdrt-org/shared/utils/enums/account-settings-mutation-key';
import { useMutationHandler } from '@module/mdrt-org/shared/utils/hooks/use-mutation-handler';
import { AccountSettingsPreviewModal, type SectionsData } from '@shared/ui-components/account-settings-preview-modal/account-settings-preview-modal';
import { type AccountSettingsPreviewModalWrapperContent } from './get-account-settings-preview-modal-wrapper-content';
type AccountSettingsPreviewModalWrapperProps = {
  cmsContent: AccountSettingsPreviewModalWrapperContent;
  initialIsModalOpen: boolean;
  personId?: number;
  sectionsData: SectionsData;
};
export const AccountSettingsPreviewModalWrapper = t0 => {
  const $ = _c(12);
  const {
    cmsContent,
    initialIsModalOpen,
    personId,
    sectionsData
  } = t0;
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mutationFunction: patchAccountSettingsAction,
      mutationKey: [AccountSettingsMutationKey.PATCH_ACCOUNT_SETTINGS],
      scrollToTop: false,
      showSuccessToast: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    mutate
  } = useMutationHandler(t1);
  let t2;
  if ($[1] !== mutate || $[2] !== personId) {
    t2 = () => {
      mutate({
        formData: {
          accountSettingStep: AccountSettingsFormStep.UserDataReviewConfirmation,
          promptUserToReviewData: false
        },
        personId
      });
    };
    $[1] = mutate;
    $[2] = personId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleModalDismiss = t2;
  let t3;
  let t4;
  if ($[4] !== initialIsModalOpen) {
    t3 = () => {
      const settingsPreviewModalWasDisplayed = sessionStorage.getItem("settingsPreviewModalWasDisplayed") === "true";
      if (initialIsModalOpen && !settingsPreviewModalWasDisplayed) {
        setIsPreviewModalOpen(true);
        sessionStorage.setItem("settingsPreviewModalWasDisplayed", "true");
      }
    };
    t4 = [initialIsModalOpen];
    $[4] = initialIsModalOpen;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== cmsContent || $[8] !== handleModalDismiss || $[9] !== isPreviewModalOpen || $[10] !== sectionsData) {
    t5 = <AccountSettingsPreviewModal cmsContent={cmsContent} dialogComponent={Dialog} dismissModalHandler={handleModalDismiss} initialIsModalOpen={isPreviewModalOpen} sectionsData={sectionsData} />;
    $[7] = cmsContent;
    $[8] = handleModalDismiss;
    $[9] = isPreviewModalOpen;
    $[10] = sectionsData;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};